import { getItemDisplayName } from './getItemDisplayName'
import { TFunction } from 'i18next'

const productTitle = (title: string, t: TFunction) => {
  const hasCheck = title.includes('✓')
  const translatedName = t(
    getItemDisplayName(title.replace('✓', '').trim(), 'products', t),
  )
  return hasCheck ? `${translatedName} ✓` : translatedName
}

export default productTitle
